import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { editGroupSet } from '../actions/GroupSetMenuActions';
import { IGroupSetInfo } from '../models/IGroupSetInfo';


export const GroupSetEditAction: IEntityAction<IGroupSetInfo, {}> = {
    name: EntityActionNames.EditGroupSet,
    translateName: Messages.editGroupSet_action,
    isVisible: (targetItems: IGroupSetInfo[], state: AppState) => {
        return targetItems.length === 1;
    },
    isClickable:  (availableActions: {}, targetItems: {}, state: AppState) => SessionUserSelectors.canManageUsers(state),
    createReduxAction: (targetItems: IGroupSetInfo[]) => editGroupSet(targetItems[0])
};